export function useGoogle(container, callback) {
  window.onload = function () {
    console.log('window-load')
    if (!window.google?.accounts?.id) return
    window.google.accounts.id.initialize({
      client_id: "448864988966-crfu90lvopnorpsc5g86ldej6dh59qba.apps.googleusercontent.com",
      callback
    });
    window.google.accounts.id.renderButton(
      document.getElementById(container),
      { theme: "outline", size: "large" }  // customization attributes
    );
    window.google.accounts.id.prompt(); // also display the One Tap dialog
  }
}

export function initGoogle(container, callback) {
  if (window.google?.accounts?.id) {
    console.log('google-init')
    window.google.accounts.id.initialize({
      client_id: "448864988966-crfu90lvopnorpsc5g86ldej6dh59qba.apps.googleusercontent.com",
      callback
    });
    window.google.accounts.id.renderButton(
      document.getElementById(container),
      { theme: "outline", size: "large" }  // customization attributes
    );
    window.google.accounts.id.prompt();
    return true
  } else {
    return false
  }
}